<template>
  <div>
    <div v-if="openType !== 0">
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="老人" prop="pId">
              <el-select v-fixZoom v-if="openType === 1" v-model="addEditForm.pId" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="elderlyChange">
                <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
                  <span>{{ getSelectElderlyShow(item) }}</span>
                </el-option>
              </el-select>
              <el-input v-else disabled v-model="addEditForm.name" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="">
              <el-input disabled v-model="addEditForm.idCardNum" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否随时入住" prop="">
              <el-radio-group v-model="addEditForm.atAnlyTime">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预约床位" prop="">
              <el-cascader v-fixZoom v-model="addEditForm.org" placeholder="请选择" :options="options" :props="props" :show-all-levels="false" clearable style="width: 100%"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="addEditForm.atAnlyTime === 0">
            <el-form-item label="计划入住时间" prop="">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.startTime"
                              type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="addEditForm.atAnlyTime === 0">
            <el-form-item label="计划退住时间" prop="">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.endTime"
                              type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="照护等级" prop="">
              <el-select v-fixZoom v-model="addEditForm.careLevel" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in careLevelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="押金" prop="">
              <el-input v-model="addEditForm.deposit" placeholder="请输入押金">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="">
          <el-input type="textarea" :rows="2" v-model="addEditForm.remarks" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="">
              <el-input v-model="addEditForm.linkMan" placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="与老人关系" prop="">
              <el-select v-fixZoom v-model="addEditForm.relationShip" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in relationShipArr" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话1" prop="">
              <el-input v-model="addEditForm.phone1" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话2" prop="">
              <el-input v-model="addEditForm.phone2" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="居住地址" prop="">
              <el-input v-model="addEditForm.addr" placeholder="请输入居住地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办理人员" prop="">
              <el-input disabled v-model="espName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-else>
      <el-descriptions style="margin: 0 20px 20px 20px" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            姓名
          </template>
          {{addEditForm.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            生日
          </template>
          {{addEditForm.birthday}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            性别
          </template>
          {{getGenderDesc(addEditForm.sex)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            身份证
          </template>
          {{addEditForm.idCardNum}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            是否随时入住
          </template>
          {{addEditForm.atAnlyTime === 1 ? '是' : '否'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            床位
          </template>
          {{addEditForm.bedName === 0 ? '--' : addEditForm.bedName}}
        </el-descriptions-item>
        <el-descriptions-item v-if="addEditForm.atAnlyTime === 0">
          <template slot="label">
            计划入住时间
          </template>
          {{addEditForm.startTime}}
        </el-descriptions-item>
        <el-descriptions-item v-if="addEditForm.atAnlyTime === 0">
          <template slot="label">
            计划退住时间
          </template>
          {{addEditForm.endTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            照护等级
          </template>
          {{getCareLevelDesc(addEditForm.careLevel)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            押金
          </template>
          {{addEditForm.deposit}}元
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">
            备注
          </template>
          {{addEditForm.remarks}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            联系人
          </template>
          {{addEditForm.linkMan}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            与老人关系
          </template>
          {{addEditForm.relationShip}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            电话1
          </template>
          {{addEditForm.phone1}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            电话2
          </template>
          {{addEditForm.phone2}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            居住地址
          </template>
          {{addEditForm.addr}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            办理人员
          </template>
          {{addEditForm.espName}}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryelderlynobed} from '../../../api/yanglaoyuan/elderly'
import {queryChildrenOrgByEid, queryChildrenOrgByOrgId} from '../../../api/organizer'
import {queryOrgHomeByOrgId} from '../../../api/yanglaoyuan/orgHome'
import {queryhomebed} from '../../../api/yanglaoyuan'
import {accomodationupdatebedwait} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'addEditAwait',
  components: {},
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    awaitObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // 打开类型 0查看 1新增 2编辑
      openType: 0,
      row: '',
      eId: 0,
      espId: 0,
      espName: '',
      elderlyArr: [],
      careLevelArr: [],
      relationShipArr: [],

      pickerOptions: {},
      options: [],
      props: {
        value: 'id',
        label: 'name',
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let nodes = []
          if (node.children && node.children.length === 0) {
            if (node.level === 0) {
              nodes = await this.getOrgData()
            } else if (node.data.org_type === 0 || node.data.org_type === 1) {
              nodes = await this.getOrgChildData(node.value)
            } else if (node.data.org_type === 2) {
              nodes = await this.getOrgHomeData(node.value)
            } else {
              nodes = await this.getHomeBedData(node.value)
            }
          }
          resolve(nodes)
        }
      },

      addEditForm: {
        org: [],
        pId: '',
        atAnlyTime: 0,
        startTime: '',
        endTime: '',
        bId: '',
        careLevel: '',
        deposit: '',
        remarks: '',
        linkMan: '',
        relationShip: '',
        phone1: '',
        phone2: '',
        addr: '',

        name: '',
        birthday: '',
        sex: '',
        idCardNum: '',
        bedName: '',
        espName: '',
        espTimeCreate: ''
      },
      addEditRules: {
        pId: [{required: true, message: '请选择老人', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname
      this.careLevelArr = this.commonType.getCareLevelArr()
      this.relationShipArr = this.commonType.getRelationShipArr()
      this.openType = this.awaitObj.openType
      this.row = this.awaitObj.row

      if (this.openType === 1) {
        this.getElderlyData()
      } else {
        this.addEditForm.pId = this.row.pid
        this.addEditForm.name = this.row.name
        this.addEditForm.birthday = this.row.birthday
        this.addEditForm.sex = this.row.sex
        this.addEditForm.idCardNum = this.row.idcard_num
        this.addEditForm.atAnlyTime = this.row.at_anly_time
        this.addEditForm.startTime = this.row.start_time
        this.addEditForm.endTime = this.row.end_time
        this.addEditForm.bId = this.row.bid
        this.addEditForm.bedName = this.row.bed_name
        this.addEditForm.careLevel = this.row.care_level.toString()
        this.addEditForm.deposit = this.row.deposit
        this.addEditForm.remarks = this.row.remarks
        this.addEditForm.linkMan = this.row.linkman
        this.addEditForm.relationShip = this.row.relationship
        this.addEditForm.phone1 = this.row.phone1
        this.addEditForm.phone2 = this.row.phone2
        this.addEditForm.addr = this.row.addr
        this.addEditForm.espName = this.row.esp_name
        this.addEditForm.espTimeCreate = this.row.esp_time_create
      }
      this.getOptions()
    },
    async getOptions () {
      let that = this
      let arr = await this.getOrgData()
      if (this.row && this.row.bed_mqttlevel && this.row.bed_mqttlevel !== '') {
        let orgArr = this.row.bed_mqttlevel.split('/')
        let parentObj = ''
        for (let i = 3; i < orgArr.length; i++) {
          let id = parseInt(orgArr[i])
          if (i === 3) {
            parentObj = arr.find(r => r.id === id)
          } else {
            parentObj = parentObj.children.find(r => r.id === id)
          }
          if (parentObj) {
            let childArr = []
            if (parentObj.org_type === 0 || parentObj.org_type === 1) {
              childArr = await that.getOrgChildData(id)
            } else if (parentObj.org_type === 2) {
              childArr = await that.getOrgHomeData(id)
            } else {
              childArr = await that.getHomeBedData(id)
            }
            parentObj.children = childArr
          }
          this.addEditForm.org.push(id)
        }
      }
      this.options = arr
    },

    getGenderDesc (gender) {
      return this.util.getGender(gender)
    },
    getCareLevelDesc (careLevel) {
      let result = ''
      let careLevelObj = this.careLevelArr.find(r => r.id === careLevel.toString())
      if (careLevelObj) {
        result = careLevelObj.name
      }
      return result
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let idCardNum = item.idcard_num && item.idcard_num !== '' ? item.idcard_num : '--'
      return elderlyName + ' / ' + idCardNum
    },
    elderlyChange () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      if (elderly) {
        this.addEditForm.idCardNum = elderly.idcard_num
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        oper_type: 0,
        pid: this.addEditForm.pId,
        eid: this.eId,
        at_anly_time: this.addEditForm.atAnlyTime,
        care_level: parseInt(this.addEditForm.careLevel),
        deposit: parseFloat(this.addEditForm.deposit),
        remarks: this.addEditForm.remarks,
        linkman: this.addEditForm.linkMan,
        relationship: this.addEditForm.relationShip,
        phone1: this.addEditForm.phone1,
        phone2: this.addEditForm.phone2,
        addr: this.addEditForm.addr,
        esp_id: this.espId,
        esp_name: this.espName
      }
      if (this.addEditForm.org.length !== 0) {
        data.bid = this.addEditForm.org[this.addEditForm.org.length - 1]
      }
      if (this.addEditForm.atAnlyTime === 0) {
        data.start_time = this.addEditForm.startTime
        data.end_time = this.addEditForm.endTime
      }
      accomodationupdatebedwait(data).then(res => {
        this.$notify({title: '成功', message: '成功轮候登记', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        oper_type: 1,
        pid: this.addEditForm.pId,
        eid: this.eId,
        at_anly_time: this.addEditForm.atAnlyTime,
        care_level: parseInt(this.addEditForm.careLevel),
        deposit: parseFloat(this.addEditForm.deposit),
        remarks: this.addEditForm.remarks,
        linkman: this.addEditForm.linkMan,
        relationship: this.addEditForm.relationShip,
        phone1: this.addEditForm.phone1,
        phone2: this.addEditForm.phone2,
        addr: this.addEditForm.addr,
        esp_id: this.espId,
        esp_name: this.espName,
        esp_time_create: this.addEditForm.espTimeCreate
      }
      if (this.addEditForm.org.length !== 0) {
        data.bid = this.addEditForm.org[this.addEditForm.org.length - 1]
      } else {
        // if (this.addEditForm.bId)
      }
      if (this.addEditForm.atAnlyTime === 0) {
        data.start_time = this.addEditForm.startTime
        data.end_time = this.addEditForm.endTime
      }
      accomodationupdatebedwait(data).then(res => {
        this.$notify({title: '成功', message: '成功轮候登记', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 查询老人
    getElderlyData () {
      let data = {
        e_id: this.eId
      }
      queryelderlynobed({}, data).then(res => {
        this.elderlyArr = res.data.elderly
      })
    },
    async getOrgData () {
      let arr = []
      let data = { eid: this.eId }
      await queryChildrenOrgByEid(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgChildData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryChildrenOrgByOrgId(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgHomeData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryOrgHomeByOrgId(data).then(res => {
        if (res.data.orghomes) {
          res.data.orghomes.forEach(orgHome => {
            orgHome.leaf = false
            orgHome.name = orgHome.room
            arr.push(orgHome)
          })
        }
      })
      return arr
    },
    async getHomeBedData (id) {
      let arr = []
      let data = {
        hid: id,
        isbind: [0, 1]
      }
      await queryhomebed(data).then(res => {
        if (res.data.homebed) {
          res.data.homebed.forEach(homeBed => {
            homeBed.leaf = true
            homeBed.name = homeBed.bed_name
            arr.push(homeBed)
          })
        }
      })
      return arr
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditAwait.vue